"use client";
import * as React from "react";
const SvgBoltFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 9 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M3.6 16h-.9l.9-6.22H.45c-.52 0-.52-.29-.34-.59l.06-.1L5.4 0h.9l-.9 6.22h3.15c.44 0 .5.3.42.46l-.06.13Q3.59 15.99 3.6 16" }));
export {
  SvgBoltFilled as default
};
